import { render, staticRenderFns } from "./invoice-details-presentational.vue?vue&type=template&id=5411f9e2&scoped=true&"
import script from "./invoice-details-presentational.ts?vue&type=script&lang=ts&"
export * from "./invoice-details-presentational.ts?vue&type=script&lang=ts&"
import style0 from "./invoice-details-presentational.scss?vue&type=style&index=0&id=5411f9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411f9e2",
  null
  
)

export default component.exports